import PubSub from "pubsub-js";
import slick from "slick-carousel";

var HeroSpotlight = function (options) {

  this.options = {
    $el: false,
    baseClass: 'comp-HeroSpotlight',
  };

  $.extend(true, this.options, options);

};

HeroSpotlight.prototype.init = function () {

  var self = this;
  self.$imagesCarousel = self.options.$el.find(`.${self.options.baseClass}__images-carousel`);
  self.$image = self.options.$el.find(`.${self.options.baseClass}__image`);
  self.$arrows = self.options.$el.find(`.${self.options.baseClass}__arrows`);
  self.$prevArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
  self.$nextArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

  if (self.$image.length > 1) {
    self.$arrows.show();

    self.$imagesCarousel.slick({
      prevArrow: self.$prevArrow,
      nextArrow: self.$nextArrow,
      swipe: true,
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
      speed: 500,
    });
  }

};

export default HeroSpotlight;